import { render, staticRenderFns } from "./carRoomPlaneList.vue?vue&type=template&id=b1768c82&scoped=true"
import script from "./carRoomPlaneList.vue?vue&type=script&lang=js"
export * from "./carRoomPlaneList.vue?vue&type=script&lang=js"
import style0 from "./carRoomPlaneList.vue?vue&type=style&index=0&id=b1768c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1768c82",
  null
  
)

export default component.exports